import { rules, patternType } from "@/common/tender/rules";
import { hooks } from "@/common/tender/hooks";
import { HouseUtils, MarginUtils, get_TENDER_PLATFORMS } from '@/common/tender/house/utils'
import { reactive } from "vue"

export const _DecryTimeSpanMinites = {
  _DecryTimeSpanMinites_x: reactive({
    Key: "_DecryTimeSpanMinites",
    Name: "（建议设置为30分钟或者60分钟）",
    Type: "componentId=input",
    Rules: [
      rules.numberValidWithDecimal(0)
    ],
    ShowRequired: true
  }),
  _DecryTimeSpanMinites_c: reactive({
    Key: "_DecryTimeSpanMinites",
    Name: "（不少于45分钟）",
    Type: "componentId=input",
    Rules: [
      rules.numberValidWithDecimal(0),
      rules.validNumberRange([45, 500], "（不少于45分钟）")
    ],
    ShowRequired: true
  })
}

export const APPLICATION_ENTERPRISE_CREDIT = {
  APPLICATION_ENTERPRISE_CREDIT: reactive({
    Key: "APPLICATION_ENTERPRISE_CREDIT",
    Name: "",
    Type: "componentId=select",
    Options: [
      {
        Name: '应用',
        Value: '应用'
      },
      {
        Name: '不应用',
        Value: '不应用'
      }
    ]
  })
}

export const IS_MUST_BIDDING_BY_LAW = {
  IS_MUST_BIDDING_BY_LAW: reactive({
    Key: "IS_MUST_BIDDING_BY_LAW_VALUE",
    Name: "是否依法必须招标",
    Type: "componentId=select",
    Disabled: false,
    Options: [
      {
        Name: "是",
        Value: "是"
      },
      {
        Name: "否",
        Value: "否"
      },
    ],
    Refs: [
      hooks.houseHooks('IS_MUST_BIDDING_BY_LAW')
    ]
  })
}

export const IS_OPEN = {
  IS_OPEN: reactive({
    Key: "IS_OPEN",
    Name: "是否公开邀请公告",
    Type: "componentId=select",
    Refs: [
      hooks.houseHooks('IS_OPEN')
    ],
    Options: [
      {
        Name: "公开",
        Value: "公开"
      },
      {
        Name: "不公开",
        Value: "不公开"
      },
    ]
  })
}

export const MARGIN_PAY_TYPE = {
  MARGIN_PAY_TYPE: reactive({
    Key: "MARGIN_PAY_TYPE",
    Name: "",
    Type: "componentId=checkbox",
    Value: [],
    flag: 0,
    Options: []
  })
}

export const MARGIN_PAY_TYPE_SIGNOUT_NO = {
  MARGIN_PAY_TYPE_SIGNOUT_NO: reactive({
    Key: "MARGIN_PAY_TYPE_SIGNOUT_NO",
    Name: "",
    Type: "componentId=select",
    Multiple: true,
    Value: [],
    Options: [],
    Refs: [
      hooks.houseHooks('MARGIN_PAY_TYPE_SIGNOUT_NO')
    ]
  })
}

export const SUP_OUTLINE_REQUIRE = {
  SUP_OUTLINE_REQUIRE: reactive({
    Key: "SUP_OUTLINE_REQUIRE",
    Name: "是否要求监理大纲",
    Type: "componentId=select",
    Options: [
      {
        Value: "要求",
        Name: "要求"
      },
      {
        Value: "不要求",
        Name: "不要求"
      }
    ],
    Refs: [
      hooks.houseHooks('SUP_OUTLINE_REQUIRE')
    ]
  })
}

export const TECHNICAL_DOCUMENTS_REQUIRE = {
  TECHNICAL_DOCUMENTS_REQUIRE: reactive({
    Key: "TECHNICAL_DOCUMENTS_REQUIRE",
    Name: "",
    Type: "componentId=select",
    Refs: [
      hooks.houseHooks('TECHNICAL_DOCUMENTS_REQUIRE')
    ],
    Options: [
      {
        Name: '要求',
        Value: '要求'
      },
      {
        Name: '不要求',
        Value: '不要求'
      }
    ],
    Disabled: false
  })
}

export const TENDER_PROJECT_CODE = {
  TENDER_PROJECT_CODE: reactive({
    Key: "TENDER_PROJECT_CODE",
    Name: "招标项目编号",
    Type: "componentId=input",
    Refs: [
      hooks.houseHooks('TENDER_PROJECT_CODE')
    ]
  })
}

export const RELEVANT_INFORMATION = {
  RELEVANT_INFORMATION: reactive({
    Key: "RELEVANT_INFORMATION",
    Name: "勘察有关资料每份售价（元）",
    Type: "componentId=input",
    Disabled: false,
    Value: "",
    Rules: [rules.numberValidWithDecimal(2)],
    Refs: [hooks.houseHooks('DOC_PRICE')]
  })
}

export const TENDER_FILE_PRICE = {
  TENDER_FILE_PRICE: reactive({
    Key: "TENDER_FILE_PRICE",
    Name: "招标文件售价（元）",
    Type: "componentId=input",
    Disabled: false,
    Value: "",
    Rules: [rules.numberValidWithDecimal(2)],
    Refs: [hooks.houseHooks('DOC_PRICE')]
  })
}

export const DOC_PRICE = {
  DOC_PRICE: reactive({
    Key: "DOC_PRICE",
    Name: "标书价格",
    Type: "componentId=input",
    Rules: [rules.numberValidWithDecimal(2)],
    Disabled: false,
    Value: ""
  })
}

export const initFormValue = {
  set(form, keys) {
    keys.forEach(key => {
      this[key](form)
    })
  },
  BID_RECIPIENTS(form) {
    let {PLATE_FORM_OPTIONS, regionId} = form
    form.BID_RECIPIENTS = regionId === 'x60004' ? '福建省国资采购平台（网址：https://ygcg.fjcqjy.com/）' : `${PLATE_FORM_OPTIONS.type}电子招标投标交易平台（网址：${PLATE_FORM_OPTIONS.web}）`
  },
  // 初始化电子招投标基本要求
  BID_BASIC_REQUIREMENTS(form) {
    let { PLATE_FORM_OPTIONS, regionId } = form
    let { type, web, phone} = PLATE_FORM_OPTIONS
    form.BID_BASIC_REQUIREMENTS = `
      1.投标人需办理深圳CA（深圳市电子商务安全证书管理有限公司）或福建CA（福建省数字安全证书管理有限公司），用于电子招投标的数字安全证书和电子印章。
      2.投标文件格式要求签字或盖章处，投标人须加盖有效的数字安全证书或电子印章。
      3.投标人应在投标截止时间前通过${ 
        regionId === 'x60004' ? `福建省国资采购平台（网址：https://ygcg.fjcqjy.com/）` :  `${type}电子招标投标交易平台 （网址：${web}）`
      }在线递交投标文件。
      具体的电子投标文件递交操作流程及步骤详见该电子交易平台上的相关说明或电话咨询电子交易平台（联系电话： ${phone}）。
    `.replace(/\s/g, '')
  },
  BIDFILE_PLACE(form) {
    let {PLATE_FORM_OPTIONS, regionId} = form
    form.BID_RECIPIENTS = regionId === 'x60004' ? '福建省国资采购平台（网址：https://ygcg.fjcqjy.com/）' : `${PLATE_FORM_OPTIONS.type}电子招标投标交易平台（网址：${PLATE_FORM_OPTIONS.web}）`
  },
  BIDER_TOOL(form) {
    let {PLATE_FORM_OPTIONS} = form
    form.TOOL_NAMEV = `${PLATE_FORM_OPTIONS.type}电子招标投标平台`
    form.TOOL_SUPPLIER = PLATE_FORM_OPTIONS.unit
    form.TOOL_PHONE = PLATE_FORM_OPTIONS.phone
    form.TOOL_REQUIRE = '投标文件递交时在线加密'
  },
  BIDDER_SUBMITREQUIRE_CLEAR_FILETYPE(form) {
    let {PLATE_FORM_OPTIONS, regionId} = form
    form.BIDDER_SUBMITREQUIRE_CLEAR_FILETYPE = regionId === 'x60004' ? '福建省国资采购平台（网址：https://ygcg.fjcqjy.com/）' : `${PLATE_FORM_OPTIONS.type}电子招标投标交易平台（网址：${PLATE_FORM_OPTIONS.web}）`
  },
  CONTRACT_PRICE_METHOD(form) {
    if(form.eval === '简易评标法（K值摇取）') form.CONTRACT_PRICE_METHOD = '发包价＝可竞争造价×（1-K）+ 不可竞争造价'
  },
  DECRYPTION_METHOD(form) {
    if(form.regionId.indexOf("x") === 0) {
      form.DECRYPTION_METHOD = '投标人应在线参加开标。开标时，电子交易平台自动提取所有投标文件，提示投标人在线开始解密。投标人应在规定的解密时间内在线进行电子投标文件的解密操作，未在规定时间内解密，其投标视为无效。'
    } else {
      form.DECRYPTION_METHOD = '投标人应在线参加开标。开标时，电子交易平台自动提取所有投标文件，提示投标人在线开始解密。投标人应在开始解密时间起六十分钟内在线进行电子投标文件的解密操作，未在规定时间内解密，其投标视为无效。'
    }
  },
  IS_NEED_CHECK_DOCS(form) {
    form.IS_NEED_CHECK_DOCS = form.regionId.indexOf("x") === -1
  },
  IS_OPEN(form) {
    IS_OPEN.IS_OPEN.Options[1].Disabled = form.regionId === '350981'
  },
  MARGIN_PAY_TYPE(form) {
    MARGIN_PAY_TYPE.MARGIN_PAY_TYPE.Options =  MarginUtils.initOptions(form)
    let value = HouseUtils.getDefaultMargins(form)
    form.WITH_DEFAULT_MARGINS = !!value.length
    form.MARGIN_PAY_TYPE = value
  },
  // 初始化发布媒体字段
  NOTICE_MEDIA3(form) {
    let {type, web} = form.PLATE_FORM_OPTIONS
    form.NOTICE_MEDIA = form.NOTICE_MEDIA3 = form.NOTICE_MEDIA4 = `福建省公共资源交易电子公共服务平台（网址：ggzyfw.fujian.gov.cn和ggzyfw.fj.gov.cn）、${type}电子招标投标交易平台（网址：${web}）`
  },
  // 国资场外标字段配置
  PLATEFORM_GZCG(form) {
    setTimeout(() => {
      let TENDER_PLATFORMS = get_TENDER_PLATFORMS()
      if(form.regionId === 'x60004') {
        form.TRADING_PLATFORM = '福建省国资采购平台'
        form.TRADING_CENTER_NAME = '福建省国资采购平台'
        form.TRADING_PLATFORM_URL = 'https://ygcg.fjcqjy.com/'
        form.TRADING_PLATFORM_ADDRESS = 'https://ygcg.fjcqjy.com/'
        form.isReportProvince = '是'
        form.IS_REPORT_PROVINCE = true
        form.IS_REPORT_PROVINCE_OUTSIDE = false
        form.NOTICE_MEDIA = form.NOTICE_MEDIA3 = form.NOTICE_MEDIA4 = `${TENDER_PLATFORMS.GGFW}、${TENDER_PLATFORMS.DZJY}${TENDER_PLATFORMS.GZCG}`

        form.IS_MUST_BIDDING_BY_LAW = false
        form.IS_MUST_BIDDING_BY_LAW_VALUE = '否'
      }      
    }, 20);
  },
  // 初始化Region_Code
  REGION_CODE(form) {
    if(form.regionId.indexOf('x') === -1) form.REGION_CODE = form.regionId
  },
  // 初始化交易中心名称
  TRADING_CENTER_NAME(form) {
    if(form.regionId === 'x00004') form.TRADING_CENTER_NAME = '随行易交易电子招标投标交易平台'
  },
  // 初始化平台信息字段
  TRADING_PLATFORM(form) {
    let {PLATE_FORM_OPTIONS} = form
    form.TRADING_PLATFORM = `${PLATE_FORM_OPTIONS.type}电子招标投标交易平台`
    form.TRADING_PLATFORM_URL = PLATE_FORM_OPTIONS.web
    form.TRADING_PLATFORM_PHONE = PLATE_FORM_OPTIONS.phone
    form.CUSTOMER_SERVICE_PHONE = PLATE_FORM_OPTIONS.phone
    form.TRADING_PLATFORM_ADDRESS = PLATE_FORM_OPTIONS.web
  },
  TENDERER_SEND_CLEAR_TYPE(form) {
    let {PLATE_FORM_OPTIONS, regionId} = form
    form.TENDERER_SEND_CLEAR_TYPE = regionId === 'x60004' ? '福建省国资采购平台（网址：https://ygcg.fjcqjy.com/）' : `${PLATE_FORM_OPTIONS.type}电子招标投标交易平台（网址：${PLATE_FORM_OPTIONS.web}）`
  },
  DOC_PRICE(form) {
    if(!/^(x\d{5,6}|350424|350430)$/.test(form.regionId)) {
      form.DOC_PRICE = form.RELEVANT_INFORMATION = form.TENDER_FILE_PRICE = '0.00'
    }
  }
}

export const initFormDisabled = {
  set(form, keys) {
    keys.forEach(key => this[key](form))
  },
  APPLICATION_ENTERPRISE_CREDIT(form) {
    APPLICATION_ENTERPRISE_CREDIT.APPLICATION_ENTERPRISE_CREDIT.Disabled = ['简易评标法', '简易评标法（K值摇取）'].indexOf(form.eval) === -1
  },
  MARGIN_PAY_TYPE(form) {
    let value = HouseUtils.getDefaultMargins(form)
    MARGIN_PAY_TYPE.MARGIN_PAY_TYPE.Options =  MarginUtils.initOptions(form)
    MARGIN_PAY_TYPE.MARGIN_PAY_TYPE.Options.forEach(option => {
      option.Disabled = value.indexOf(option.Value) >= 0
    })
  },
  MARGIN_PAY_TYPE_SIGNOUT_NO(form) {
    MARGIN_PAY_TYPE_SIGNOUT_NO.MARGIN_PAY_TYPE_SIGNOUT_NO.Options = MarginUtils.initNoOptions(form)
  },
  PLATEFORM_GZCG(form) {
    IS_MUST_BIDDING_BY_LAW.IS_MUST_BIDDING_BY_LAW.Disabled = form.regionId === 'x60004'
  },
  SUP_OUTLINE_REQUIRE(form) {
    SUP_OUTLINE_REQUIRE.SUP_OUTLINE_REQUIRE.Disabled = form.type === '监理' && form.eval === '简易评标法'
  },
  TENDER_PROJECT_CODE(form) {
    TENDER_PROJECT_CODE.TENDER_PROJECT_CODE.Disabled = form.regionId.indexOf('x') === -1
  },
  TECHNICAL_DOCUMENTS_REQUIRE(form) {
    TECHNICAL_DOCUMENTS_REQUIRE.TECHNICAL_DOCUMENTS_REQUIRE.Disabled = ['简易评标法', '简易评标法（K值摇取）'].indexOf(form.eval) >= 0
  },
  DOC_PRICE(form) {
    if(!/^(x\d{5,6}|350424|350430)$/.test(form.regionId)) {
      DOC_PRICE.DOC_PRICE.Disabled = RELEVANT_INFORMATION.RELEVANT_INFORMATION.Disabled = TENDER_FILE_PRICE.TENDER_FILE_PRICE.Disabled = !/^(x\d{5}|350424|350430|350181)$/.test(form.regionId)
    }
  }
}

export default {
  _DecryTimeSpanMinites,
  APPLICATION_ENTERPRISE_CREDIT,
  IS_MUST_BIDDING_BY_LAW,
  IS_OPEN,
  DOC_PRICE,
  MARGIN_PAY_TYPE,
  MARGIN_PAY_TYPE_SIGNOUT_NO,
  RELEVANT_INFORMATION,
  TENDER_FILE_PRICE,
  TENDER_PROJECT_CODE,
  TECHNICAL_DOCUMENTS_REQUIRE,
  SUP_OUTLINE_REQUIRE,
  initFormValue,
  initFormDisabled
}